module.exports = __webpack_public_path__ + "img/logo3.c9c855a0.svg";